import { panelStopLossHowLayoutByLang } from './panelStopLossHowLayoutI18n';

/**
 * User-panel copy added/updated for platform rules, referral commissions,
 * daily interest UI, wallet withdraw, deposits empty state, stop-loss explainer.
 */
const panelUserPlatformTodayBase = {
  es: {
    'user.referral.link.hintLong':
      'Invita amigos a MineMe con tu enlace personal y ayuda a crecer la red.',
    'user.referral.stats.direct': 'Referidos directos',
    'user.referral.stats.indirect': 'Referidos indirectos',
    'user.referral.stats.directRate': 'Comisión nivel 1',
    'user.referral.stats.indirectRate': 'Comisión nivel 2',
    'user.referral.stats.rateValue': '{{pct}}% sobre la inversión',
    'user.referral.stats.earnings': 'Ganancias por referidos',
    'user.referral.tree.title': 'Tu red de referidos',
    'user.referral.tree.you': 'Tú',
    'user.referral.tree.directLevel': 'Nivel directo',
    'user.referral.tree.indirectLevel': 'Nivel indirecto',
    'user.referral.tree.noDirect': 'Aún no hay referidos directos',
    'user.referral.tree.noIndirect': 'Aún no hay referidos indirectos',
    'user.referral.tree.directCount': '{{n}} referidos directos',
    'user.referral.tree.indirectCount': '{{n}} referidos indirectos',
    'user.withdraw.form.minAmount': 'Retiro mínimo: {{amount}}',
    'user.withdraw.form.feeTitle': 'Comisión de retiro: {{pct}}%',
    'user.withdraw.form.feeBody':
      'Se deduce un {{pct}}% del importe del retiro. La cancelación anticipada de planes tiene una comisión aparte.',
    'user.withdraw.form.noFeeBody':
      'Los retiros a billetera no tienen comisión de plataforma. La cancelación anticipada de planes tiene una tarifa aparte.',
    'user.withdraw.rules.feeNote':
      'Los retiros a billetera tienen una comisión del {{pct}}%. La cancelación anticipada de planes usa otra tarifa.',
    'user.withdraw.rules.noFeeNote':
      'Sin comisión en retiros a billetera. La cancelación anticipada de planes usa otra tarifa.',
    'user.withdraw.toast.tooLowAfterFee': 'El importe es demasiado bajo tras la comisión de plataforma',
    'user.withdraw.toast.minUsd': 'El retiro mínimo es {{amount}}',
    'user.withdraw.form.weekendOnlyHint':
      'Los retiros a billetera solo están disponibles sábado y domingo (hora local). La cancelación anticipada de planes no se ve afectada.',
    'user.withdraw.toast.weekendOnly':
      'Los retiros a billetera solo están disponibles sábado y domingo en tu zona horaria.',
    'user.withdraw.history.empty': 'Aún no hay retiros. El historial aparecerá aquí.',
    'user.investments.modal.hintWeekdayOnly':
      'El interés se acredita al saldo disponible solo entre semana',
    'user.investments.modal.toastWeekdayOnly':
      'Las suscripciones a planes solo están disponibles de lunes a viernes en tu zona horaria.',
    'user.investments.history.rateDay': '{{pct}}%/día',
    'user.investments.active.ratePerDay': '{{pct}}% / día',
    'user.dashboard.invest.detail.perDay': '{{pct}}% / día',
    'user.deposit.history.emptyTitle': 'Aún no hay depósitos',
    'user.deposit.history.emptyDesc': 'Tu historial de depósitos aparecerá aquí',
    'user.stopLoss.slots.title': 'Mis slots de Stop-Loss',
    'user.stopLoss.explainer.title': '¿Qué es la protección Stop-Loss?',
    'user.stopLoss.explainer.body':
      'El stop-loss termina automáticamente tu inversión cuando su valor cae por debajo de un umbral que defines, protegiendo tu capital ante caídas repentinas y la volatilidad del mercado.',
    'user.stopLoss.explainer.badge.nonRefundable': 'Pago no reembolsable',
    'user.stopLoss.explainer.badge.monitoring': 'Monitoreo automatizado 24/7',
  },

  de: {
    'user.referral.link.hintLong':
      'Laden Sie Freunde mit Ihrem persönlichen Link zu MineMe ein und helfen Sie, das Netzwerk zu vergrößern.',
    'user.referral.stats.direct': 'Direkte Empfehlungen',
    'user.referral.stats.indirect': 'Indirekte Empfehlungen',
    'user.referral.stats.directRate': 'Provision Stufe 1',
    'user.referral.stats.indirectRate': 'Provision Stufe 2',
    'user.referral.stats.rateValue': '{{pct}}% auf Investition',
    'user.referral.stats.earnings': 'Empfehlungseinnahmen',
    'user.referral.tree.title': 'Ihr Empfehlungsnetzwerk',
    'user.referral.tree.you': 'Sie',
    'user.referral.tree.directLevel': 'Direkte Ebene',
    'user.referral.tree.indirectLevel': 'Indirekte Ebene',
    'user.referral.tree.noDirect': 'Noch keine direkten Empfehlungen',
    'user.referral.tree.noIndirect': 'Noch keine indirekten Empfehlungen',
    'user.referral.tree.directCount': '{{n}} direkte Empfehlungen',
    'user.referral.tree.indirectCount': '{{n}} indirekte Empfehlungen',
    'user.withdraw.form.minAmount': 'Mindestauszahlung: {{amount}}',
    'user.withdraw.form.feeTitle': 'Auszahlungsgebühr: {{pct}}%',
    'user.withdraw.form.feeBody':
      'Es werden {{pct}}% vom Auszahlungsbetrag abgezogen. Die vorzeitige Plan-Kündigung hat eine separate Gebühr.',
    'user.withdraw.form.noFeeBody':
      'Wallet-Auszahlungen haben keine Plattformgebühr. Die vorzeitige Plan-Kündigung hat eine separate Gebühr.',
    'user.withdraw.rules.feeNote':
      'Auf Wallet-Auszahlungen fallen {{pct}}% Plattformgebühr an. Die vorzeitige Plan-Kündigung hat eine separate Gebühr.',
    'user.withdraw.rules.noFeeNote':
      'Keine Plattformgebühr auf Wallet-Auszahlungen. Die vorzeitige Plan-Kündigung hat eine separate Gebühr.',
    'user.withdraw.toast.tooLowAfterFee': 'Der Betrag ist nach der Plattformgebühr zu niedrig',
    'user.withdraw.toast.minUsd': 'Mindestauszahlung ist {{amount}}',
    'user.withdraw.form.weekendOnlyHint':
      'Wallet-Auszahlungen sind nur Samstag und Sonntag möglich (Ortszeit). Vorzeitige Plan-Kündigung ist nicht betroffen.',
    'user.withdraw.toast.weekendOnly':
      'Wallet-Auszahlungen sind in Ihrer Zeitzone nur Samstag und Sonntag möglich.',
    'user.withdraw.history.empty': 'Noch keine Auszahlungen. Der Verlauf erscheint hier.',
    'user.investments.modal.hintWeekdayOnly':
      'Zinsen werden nur an Werktagen dem verfügbaren Guthaben gutgeschrieben',
    'user.investments.modal.toastWeekdayOnly':
      'Planzeichnungen sind in Ihrer Zeitzone nur Montag–Freitag möglich.',
    'user.investments.history.rateDay': '{{pct}}%/Tag',
    'user.investments.active.ratePerDay': '{{pct}}% / Tag',
    'user.dashboard.invest.detail.perDay': '{{pct}}% / Tag',
    'user.deposit.history.emptyTitle': 'Noch keine Einzahlungen',
    'user.deposit.history.emptyDesc': 'Ihr Einzahlungsverlauf erscheint hier',
    'user.stopLoss.slots.title': 'Meine Stop-Loss-Slots',
    'user.stopLoss.explainer.title': 'Was ist Stop-Loss-Schutz?',
    'user.stopLoss.explainer.body':
      'Stop-Loss beendet Ihre Investition automatisch, wenn der Wert unter einen von Ihnen festgelegten Schwellenwert fällt und schützt so Ihr Kapital vor plötzlichen Marktrücksetzern und Volatilität.',
    'user.stopLoss.explainer.badge.nonRefundable': 'Nicht erstattbare Zahlung',
    'user.stopLoss.explainer.badge.monitoring': 'Automatisierte 24/7-Überwachung',
  },

  fr: {
    'user.referral.link.hintLong':
      'Invitez des amis sur MineMe avec votre lien personnel et aidez à développer le réseau.',
    'user.referral.stats.direct': 'Filleuls directs',
    'user.referral.stats.indirect': 'Filleuls indirects',
    'user.referral.stats.directRate': 'Commission niveau 1',
    'user.referral.stats.indirectRate': 'Commission niveau 2',
    'user.referral.stats.rateValue': '{{pct}}% sur l\'investissement',
    'user.referral.stats.earnings': 'Gains de parrainage',
    'user.referral.tree.title': 'Votre réseau de parrainage',
    'user.referral.tree.you': 'Vous',
    'user.referral.tree.directLevel': 'Niveau direct',
    'user.referral.tree.indirectLevel': 'Niveau indirect',
    'user.referral.tree.noDirect': 'Pas encore de filleuls directs',
    'user.referral.tree.noIndirect': 'Pas encore de filleuls indirects',
    'user.referral.tree.directCount': '{{n}} filleuls directs',
    'user.referral.tree.indirectCount': '{{n}} filleuls indirects',
    'user.withdraw.form.minAmount': 'Retrait minimum : {{amount}}',
    'user.withdraw.form.feeTitle': 'Frais de retrait : {{pct}}%',
    'user.withdraw.form.feeBody':
      'Des frais de {{pct}}% sont déduits du montant du retrait. L\'annulation anticipée d\'un plan utilise des frais distincts.',
    'user.withdraw.form.noFeeBody':
      'Les retraits vers le portefeuille sont sans frais de plateforme. L\'annulation anticipée d\'un plan utilise des frais distincts.',
    'user.withdraw.rules.feeNote':
      'Des frais de plateforme de {{pct}}% s\'appliquent aux retraits portefeuille. L\'annulation anticipée d\'un plan utilise des frais distincts.',
    'user.withdraw.rules.noFeeNote':
      'Aucun frais de plateforme sur les retraits portefeuille. L\'annulation anticipée d\'un plan utilise des frais distincts.',
    'user.withdraw.toast.tooLowAfterFee': 'Le montant est trop faible après les frais de plateforme',
    'user.withdraw.toast.minUsd': 'Le retrait minimum est {{amount}}',
    'user.withdraw.form.weekendOnlyHint':
      'Les retraits portefeuille sont possibles uniquement le samedi et le dimanche (heure locale). L\'annulation anticipée d\'un plan n\'est pas concernée.',
    'user.withdraw.toast.weekendOnly':
      'Les retraits portefeuille ne sont possibles que le samedi et le dimanche dans votre fuseau horaire.',
    'user.withdraw.history.empty': 'Aucun retrait pour le moment. Votre historique apparaîtra ici.',
    'user.investments.modal.hintWeekdayOnly':
      'Les intérêts sont crédités sur le solde disponible en semaine uniquement',
    'user.investments.modal.toastWeekdayOnly':
      'Les souscriptions aux plans ne sont possibles que du lundi au vendredi dans votre fuseau horaire.',
    'user.investments.history.rateDay': '{{pct}}%/jour',
    'user.investments.active.ratePerDay': '{{pct}}% / jour',
    'user.dashboard.invest.detail.perDay': '{{pct}}% / jour',
    'user.deposit.history.emptyTitle': 'Aucun dépôt pour le moment',
    'user.deposit.history.emptyDesc': 'Votre historique de dépôts apparaîtra ici',
    'user.stopLoss.slots.title': 'Mes slots Stop-Loss',
    'user.stopLoss.explainer.title': 'Qu\'est-ce que la protection Stop-Loss ?',
    'user.stopLoss.explainer.body':
      'Le stop-loss met automatiquement fin à votre investissement lorsque sa valeur descend sous un seuil que vous définissez, protégeant votre capital des baisses soudaines et de la volatilité.',
    'user.stopLoss.explainer.badge.nonRefundable': 'Paiement non remboursable',
    'user.stopLoss.explainer.badge.monitoring': 'Surveillance automatisée 24h/24',
  },

  ar: {
    'user.referral.link.hintLong': 'ادعُ الأصدقاء إلى MineMe برابطك الشخصي وساعد على نمو الشبكة.',
    'user.referral.stats.direct': 'إحالات مباشرة',
    'user.referral.stats.indirect': 'إحالات غير مباشرة',
    'user.referral.stats.directRate': 'عمولة المستوى 1',
    'user.referral.stats.indirectRate': 'عمولة المستوى 2',
    'user.referral.stats.rateValue': '{{pct}}% على الاستثمار',
    'user.referral.stats.earnings': 'أرباح الإحالة',
    'user.referral.tree.title': 'شبكة الإحالات الخاصة بك',
    'user.referral.tree.you': 'أنت',
    'user.referral.tree.directLevel': 'المستوى المباشر',
    'user.referral.tree.indirectLevel': 'المستوى غير المباشر',
    'user.referral.tree.noDirect': 'لا توجد إحالات مباشرة بعد',
    'user.referral.tree.noIndirect': 'لا توجد إحالات غير مباشرة بعد',
    'user.referral.tree.directCount': '{{n}} إحالة مباشرة',
    'user.referral.tree.indirectCount': '{{n}} إحالة غير مباشرة',
    'user.withdraw.form.minAmount': 'الحد الأدنى للسحب: {{amount}}',
    'user.withdraw.form.feeTitle': 'رسوم السحب: {{pct}}%',
    'user.withdraw.form.feeBody':
      'يتم خصم {{pct}}% من مبلغ السحب. إلغاء الخطة المبكر له رسوم منفصلة.',
    'user.withdraw.form.noFeeBody':
      'سحوبات المحفظة بدون رسوم منصة. إلغاء الخطة المبكر له رسوم منفصلة.',
    'user.withdraw.rules.feeNote':
      'تُطبَّق رسوم منصة بنسبة {{pct}}% على سحوبات المحفظة. إلغاء الخطة المبكر له رسوم منفصلة.',
    'user.withdraw.rules.noFeeNote':
      'لا توجد رسوم منصة على سحوبات المحفظة. إلغاء الخطة المبكر له رسوم منفصلة.',
    'user.withdraw.toast.tooLowAfterFee': 'المبلغ منخفض جداً بعد رسوم المنصة',
    'user.withdraw.toast.minUsd': 'الحد الأدنى للسحب هو {{amount}}',
    'user.withdraw.form.weekendOnlyHint':
      'سحوبات المحفظة متاحة يومي السبت والأحد فقط (بتوقيتك المحلي). إلغاء الخطة المبكر غير متأثر.',
    'user.withdraw.toast.weekendOnly':
      'سحوبات المحفظة متاحة يومي السبت والأحد فقط في منطقتك الزمنية.',
    'user.withdraw.history.empty': 'لا توجد سحوبات بعد. سيظهر سجل السحوبات هنا.',
    'user.investments.modal.hintWeekdayOnly':
      'تُضاف الفائدة إلى الرصيد المتاح أيام الأسبوع فقط',
    'user.investments.modal.toastWeekdayOnly':
      'اشتراكات الخطط متاحة من الاثنين إلى الجمعة فقط في منطقتك الزمنية.',
    'user.investments.history.rateDay': '{{pct}}%/يوم',
    'user.investments.active.ratePerDay': '{{pct}}% / يوم',
    'user.dashboard.invest.detail.perDay': '{{pct}}% / يوم',
    'user.deposit.history.emptyTitle': 'لا توجد إيداعات بعد',
    'user.deposit.history.emptyDesc': 'سيظهر سجل الإيداعات هنا',
    'user.stopLoss.slots.title': 'فتحات وقف الخسارة الخاصة بي',
    'user.stopLoss.explainer.title': 'ما هي حماية وقف الخسارة؟',
    'user.stopLoss.explainer.body':
      'يوقف وقف الخسارة استثمارك تلقائياً عندما ينخفض قيمته دون حد تحدده مسبقاً، لحماية رأس المال من الهبوط المفاجئ وتقلبات السوق.',
    'user.stopLoss.explainer.badge.nonRefundable': 'دفع غير قابل للاسترداد',
    'user.stopLoss.explainer.badge.monitoring': 'مراقبة آلية على مدار الساعة',
  },

  ja: {
    'user.referral.link.hintLong': '個人用リンクで友人をMineMeに招待し、ネットワークを広げましょう。',
    'user.referral.stats.direct': '直接紹介',
    'user.referral.stats.indirect': '間接紹介',
    'user.referral.stats.directRate': 'レベル1コミッション',
    'user.referral.stats.indirectRate': 'レベル2コミッション',
    'user.referral.stats.rateValue': '投資額の{{pct}}%',
    'user.referral.stats.earnings': '紹介収益',
    'user.referral.tree.title': '紹介ネットワーク',
    'user.referral.tree.you': 'あなた',
    'user.referral.tree.directLevel': '直接レベル',
    'user.referral.tree.indirectLevel': '間接レベル',
    'user.referral.tree.noDirect': '直接紹介はまだありません',
    'user.referral.tree.noIndirect': '間接紹介はまだありません',
    'user.referral.tree.directCount': '直接紹介 {{n}} 件',
    'user.referral.tree.indirectCount': '間接紹介 {{n}} 件',
    'user.withdraw.form.minAmount': '最低出金額: {{amount}}',
    'user.withdraw.form.feeTitle': '出金手数料: {{pct}}%',
    'user.withdraw.form.feeBody':
      '出金額の{{pct}}%が手数料として差し引かれます。プランの早期解約は別料金です。',
    'user.withdraw.form.noFeeBody':
      'ウォレット出金にプラットフォーム手数料はかかりません。プランの早期解約は別料金です。',
    'user.withdraw.rules.feeNote':
      'ウォレット出金には{{pct}}%のプラットフォーム手数料がかかります。プランの早期解約は別料金です。',
    'user.withdraw.rules.noFeeNote':
      'ウォレット出金にプラットフォーム手数料はかかりません。プランの早期解約は別料金です。',
    'user.withdraw.toast.tooLowAfterFee': '手数料差し引き後の金額が低すぎます',
    'user.withdraw.toast.minUsd': '最低出金額は{{amount}}です',
    'user.withdraw.form.weekendOnlyHint':
      'ウォレット出金は土曜・日曜のみ可能です（現地時間）。プランの早期解約には影響しません。',
    'user.withdraw.toast.weekendOnly':
      'ウォレット出金はお住まいのタイムゾーンで土曜・日曜のみ可能です。',
    'user.withdraw.history.empty': '出金履歴はまだありません。ここに表示されます。',
    'user.investments.modal.hintWeekdayOnly':
      '利息は平日のみ利用可能残高に付与されます',
    'user.investments.modal.toastWeekdayOnly':
      'プラン申込はお住まいのタイムゾーンで月〜金のみ可能です。',
    'user.investments.history.rateDay': '{{pct}}%/日',
    'user.investments.active.ratePerDay': '{{pct}}% / 日',
    'user.dashboard.invest.detail.perDay': '{{pct}}% / 日',
    'user.deposit.history.emptyTitle': '入金はまだありません',
    'user.deposit.history.emptyDesc': '入金履歴はここに表示されます',
    'user.stopLoss.slots.title': 'マイ・ストップロス枠',
    'user.stopLoss.explainer.title': 'ストップロス保護とは？',
    'user.stopLoss.explainer.body':
      'ストップロスは、設定したしきい値を下回ったときに投資を自動終了し、急落やボラティリティから元本を守ります。',
    'user.stopLoss.explainer.badge.nonRefundable': '返金不可のお支払い',
    'user.stopLoss.explainer.badge.monitoring': '24時間365日の自動監視',
  },

  ko: {
    'user.referral.link.hintLong': '개인 링크로 친구를 MineMe에 초대하고 네트워크를 키우세요.',
    'user.referral.stats.direct': '직접 추천',
    'user.referral.stats.indirect': '간접 추천',
    'user.referral.stats.directRate': '1단계 커미션',
    'user.referral.stats.indirectRate': '2단계 커미션',
    'user.referral.stats.rateValue': '투자금의 {{pct}}%',
    'user.referral.stats.earnings': '추천 수익',
    'user.referral.tree.title': '추천 네트워크',
    'user.referral.tree.you': '나',
    'user.referral.tree.directLevel': '직접 단계',
    'user.referral.tree.indirectLevel': '간접 단계',
    'user.referral.tree.noDirect': '직접 추천이 아직 없습니다',
    'user.referral.tree.noIndirect': '간접 추천이 아직 없습니다',
    'user.referral.tree.directCount': '직접 추천 {{n}}명',
    'user.referral.tree.indirectCount': '간접 추천 {{n}}명',
    'user.withdraw.form.minAmount': '최소 출금: {{amount}}',
    'user.withdraw.form.feeTitle': '출금 수수료: {{pct}}%',
    'user.withdraw.form.feeBody':
      '출금 금액의 {{pct}}%가 수수료로 차감됩니다. 플랜 조기 해지는 별도 수수료가 적용됩니다.',
    'user.withdraw.form.noFeeBody':
      '지갑 출금에는 플랫폼 수수료가 없습니다. 플랜 조기 해지는 별도 수수료가 적용됩니다.',
    'user.withdraw.rules.feeNote':
      '지갑 출금에 {{pct}}% 플랫폼 수수료가 적용됩니다. 플랜 조기 해지는 별도 수수료입니다.',
    'user.withdraw.rules.noFeeNote':
      '지갑 출금에 플랫폼 수수료가 없습니다. 플랜 조기 해지는 별도 수수료입니다.',
    'user.withdraw.toast.tooLowAfterFee': '수수료 차감 후 금액이 너무 낮습니다',
    'user.withdraw.toast.minUsd': '최소 출금액은 {{amount}}입니다',
    'user.withdraw.form.weekendOnlyHint':
      '지갑 출금은 토요일과 일요일에만 가능합니다(현지 시간). 플랜 조기 해지에는 영향이 없습니다.',
    'user.withdraw.toast.weekendOnly':
      '지갑 출금은 현지 시간 기준 토요일과 일요일에만 가능합니다.',
    'user.withdraw.history.empty': '아직 출금 내역이 없습니다. 여기에 표시됩니다.',
    'user.investments.modal.hintWeekdayOnly':
      '이자는 평일에만 사용 가능 잔액으로 적립됩니다',
    'user.investments.modal.toastWeekdayOnly':
      '플랜 가입은 귀하의 시간대에서 월–금에만 가능합니다.',
    'user.investments.history.rateDay': '{{pct}}%/일',
    'user.investments.active.ratePerDay': '{{pct}}% / 일',
    'user.dashboard.invest.detail.perDay': '{{pct}}% / 일',
    'user.deposit.history.emptyTitle': '아직 입금이 없습니다',
    'user.deposit.history.emptyDesc': '입금 내역이 여기에 표시됩니다',
    'user.stopLoss.slots.title': '내 스톱로스 슬롯',
    'user.stopLoss.explainer.title': '스톱로스 보호란?',
    'user.stopLoss.explainer.body':
      '스톱로스는 설정한 한도 아래로 가치가 떨어지면 투자를 자동 종료하여 급락과 변동성으로부터 원금을 보호합니다.',
    'user.stopLoss.explainer.badge.nonRefundable': '환불 불가 결제',
    'user.stopLoss.explainer.badge.monitoring': '24/7 자동 모니터링',
  },

  pt: {
    'user.referral.link.hintLong':
      'Convide amigos para a MineMe com o seu link pessoal e ajude a expandir a rede.',
    'user.referral.stats.direct': 'Indicações diretas',
    'user.referral.stats.indirect': 'Indicações indiretas',
    'user.referral.stats.directRate': 'Comissão nível 1',
    'user.referral.stats.indirectRate': 'Comissão nível 2',
    'user.referral.stats.rateValue': '{{pct}}% sobre o investimento',
    'user.referral.stats.earnings': 'Ganhos de indicação',
    'user.referral.tree.title': 'A sua rede de indicações',
    'user.referral.tree.you': 'Você',
    'user.referral.tree.directLevel': 'Nível direto',
    'user.referral.tree.indirectLevel': 'Nível indireto',
    'user.referral.tree.noDirect': 'Ainda sem indicações diretas',
    'user.referral.tree.noIndirect': 'Ainda sem indicações indiretas',
    'user.referral.tree.directCount': '{{n}} indicações diretas',
    'user.referral.tree.indirectCount': '{{n}} indicações indiretas',
    'user.withdraw.form.minAmount': 'Levantamento mínimo: {{amount}}',
    'user.withdraw.form.feeTitle': 'Taxa de levantamento: {{pct}}%',
    'user.withdraw.form.feeBody':
      'É deduzido {{pct}}% do valor do levantamento. O cancelamento antecipado do plano tem taxa separada.',
    'user.withdraw.form.noFeeBody':
      'Levantamentos para carteira sem taxa de plataforma. O cancelamento antecipado do plano tem taxa separada.',
    'user.withdraw.rules.feeNote':
      'Aplica-se uma taxa de plataforma de {{pct}}% aos levantamentos. O cancelamento antecipado do plano tem taxa separada.',
    'user.withdraw.rules.noFeeNote':
      'Sem taxa de plataforma nos levantamentos. O cancelamento antecipado do plano tem taxa separada.',
    'user.withdraw.toast.tooLowAfterFee': 'O valor é demasiado baixo após a taxa da plataforma',
    'user.withdraw.toast.minUsd': 'O levantamento mínimo é {{amount}}',
    'user.withdraw.form.weekendOnlyHint':
      'Levantamentos para carteira só estão disponíveis sábado e domingo (hora local). O cancelamento antecipado do plano não é afetado.',
    'user.withdraw.toast.weekendOnly':
      'Levantamentos para carteira só estão disponíveis sábado e domingo no seu fuso horário.',
    'user.withdraw.history.empty': 'Ainda não há levantamentos. O histórico aparecerá aqui.',
    'user.investments.modal.hintWeekdayOnly':
      'Os juros são creditados no saldo disponível apenas em dias úteis',
    'user.investments.modal.toastWeekdayOnly':
      'Subscrições de planos só estão disponíveis de segunda a sexta no seu fuso horário.',
    'user.investments.history.rateDay': '{{pct}}%/dia',
    'user.investments.active.ratePerDay': '{{pct}}% / dia',
    'user.dashboard.invest.detail.perDay': '{{pct}}% / dia',
    'user.deposit.history.emptyTitle': 'Ainda sem depósitos',
    'user.deposit.history.emptyDesc': 'O seu histórico de depósitos aparecerá aqui',
    'user.stopLoss.slots.title': 'Os meus slots Stop-Loss',
    'user.stopLoss.explainer.title': 'O que é a proteção Stop-Loss?',
    'user.stopLoss.explainer.body':
      'O stop-loss encerra automaticamente o seu investimento quando o valor desce abaixo de um limiar definido, protegendo o capital de quedas súbitas e volatilidade.',
    'user.stopLoss.explainer.badge.nonRefundable': 'Pagamento não reembolsável',
    'user.stopLoss.explainer.badge.monitoring': 'Monitorização automática 24/7',
  },

  it: {
    'user.referral.link.hintLong':
      'Invita amici su MineMe con il tuo link personale e aiuta a far crescere la rete.',
    'user.referral.stats.direct': 'Referral diretti',
    'user.referral.stats.indirect': 'Referral indiretti',
    'user.referral.stats.directRate': 'Commissione livello 1',
    'user.referral.stats.indirectRate': 'Commissione livello 2',
    'user.referral.stats.rateValue': '{{pct}}% sull\'investimento',
    'user.referral.stats.earnings': 'Guadagni da referral',
    'user.referral.tree.title': 'La tua rete di referral',
    'user.referral.tree.you': 'Tu',
    'user.referral.tree.directLevel': 'Livello diretto',
    'user.referral.tree.indirectLevel': 'Livello indiretto',
    'user.referral.tree.noDirect': 'Nessun referral diretto ancora',
    'user.referral.tree.noIndirect': 'Nessun referral indiretto ancora',
    'user.referral.tree.directCount': '{{n}} referral diretti',
    'user.referral.tree.indirectCount': '{{n}} referral indiretti',
    'user.withdraw.form.minAmount': 'Prelievo minimo: {{amount}}',
    'user.withdraw.form.feeTitle': 'Commissione prelievo: {{pct}}%',
    'user.withdraw.form.feeBody':
      'Viene detratto il {{pct}}% dell\'importo del prelievo. La cancellazione anticipata del piano ha una commissione separata.',
    'user.withdraw.form.noFeeBody':
      'I prelievi wallet non hanno commissione piattaforma. La cancellazione anticipata del piano ha una commissione separata.',
    'user.withdraw.rules.feeNote':
      'Su i prelievi wallet si applica una commissione piattaforma del {{pct}}%. La cancellazione anticipata del piano ha una commissione separata.',
    'user.withdraw.rules.noFeeNote':
      'Nessuna commissione piattaforma sui prelievi wallet. La cancellazione anticipata del piano ha una commissione separata.',
    'user.withdraw.toast.tooLowAfterFee': 'L\'importo è troppo basso dopo la commissione piattaforma',
    'user.withdraw.toast.minUsd': 'Il prelievo minimo è {{amount}}',
    'user.withdraw.form.weekendOnlyHint':
      'I prelievi wallet sono disponibili solo sabato e domenica (ora locale). La cancellazione anticipata del piano non è interessata.',
    'user.withdraw.toast.weekendOnly':
      'I prelievi wallet sono disponibili solo sabato e domenica nel tuo fuso orario.',
    'user.withdraw.history.empty': 'Nessun prelievo ancora. La cronologia apparirà qui.',
    'user.investments.modal.hintWeekdayOnly':
      'Gli interessi vengono accreditati sul saldo disponibile solo nei giorni feriali',
    'user.investments.modal.toastWeekdayOnly':
      'Le sottoscrizioni ai piani sono disponibili solo dal lunedì al venerdì nel tuo fuso orario.',
    'user.investments.history.rateDay': '{{pct}}%/giorno',
    'user.investments.active.ratePerDay': '{{pct}}% / giorno',
    'user.dashboard.invest.detail.perDay': '{{pct}}% / giorno',
    'user.deposit.history.emptyTitle': 'Nessun deposito ancora',
    'user.deposit.history.emptyDesc': 'La cronologia dei depositi apparirà qui',
    'user.stopLoss.slots.title': 'I miei slot Stop-Loss',
    'user.stopLoss.explainer.title': 'Cos\'è la protezione Stop-Loss?',
    'user.stopLoss.explainer.body':
      'Lo stop-loss termina automaticamente il tuo investimento quando il valore scende sotto una soglia che imposti, proteggendo il capitale da cali improvvisi e volatilità.',
    'user.stopLoss.explainer.badge.nonRefundable': 'Pagamento non rimborsabile',
    'user.stopLoss.explainer.badge.monitoring': 'Monitoraggio automatico 24/7',
  },

  ru: {
    'user.referral.link.hintLong':
      'Приглашайте друзей в MineMe по личной ссылке и помогайте развивать сеть.',
    'user.referral.stats.direct': 'Прямые рефералы',
    'user.referral.stats.indirect': 'Косвенные рефералы',
    'user.referral.stats.directRate': 'Комиссия уровня 1',
    'user.referral.stats.indirectRate': 'Комиссия уровня 2',
    'user.referral.stats.rateValue': '{{pct}}% с инвестиции',
    'user.referral.stats.earnings': 'Реферальный доход',
    'user.referral.tree.title': 'Ваша реферальная сеть',
    'user.referral.tree.you': 'Вы',
    'user.referral.tree.directLevel': 'Прямой уровень',
    'user.referral.tree.indirectLevel': 'Косвенный уровень',
    'user.referral.tree.noDirect': 'Прямых рефералов пока нет',
    'user.referral.tree.noIndirect': 'Косвенных рефералов пока нет',
    'user.referral.tree.directCount': '{{n}} прямых рефералов',
    'user.referral.tree.indirectCount': '{{n}} косвенных рефералов',
    'user.withdraw.form.minAmount': 'Минимальный вывод: {{amount}}',
    'user.withdraw.form.feeTitle': 'Комиссия за вывод: {{pct}}%',
    'user.withdraw.form.feeBody':
      'С суммы вывода удерживается {{pct}}%. Досрочная отмена плана — отдельная комиссия.',
    'user.withdraw.form.noFeeBody':
      'Вывод на кошелёк без комиссии платформы. Досрочная отмена плана — отдельная комиссия.',
    'user.withdraw.rules.feeNote':
      'На выводы действует комиссия платформы {{pct}}%. Досрочная отмена плана — отдельная комиссия.',
    'user.withdraw.rules.noFeeNote':
      'Вывод на кошелёк без комиссии платформы. Досрочная отмена плана — отдельная комиссия.',
    'user.withdraw.toast.tooLowAfterFee': 'Сумма слишком мала после комиссии платформы',
    'user.withdraw.toast.minUsd': 'Минимальная сумма вывода — {{amount}}',
    'user.withdraw.form.weekendOnlyHint':
      'Вывод на кошелёк доступен только в субботу и воскресенье (местное время). Досрочная отмена плана не затрагивается.',
    'user.withdraw.toast.weekendOnly':
      'Вывод на кошелёк доступен только в субботу и воскресенье в вашем часовом поясе.',
    'user.withdraw.history.empty': 'Выводов пока нет. История появится здесь.',
    'user.investments.modal.hintWeekdayOnly':
      'Проценты зачисляются на доступный баланс только в будние дни',
    'user.investments.modal.toastWeekdayOnly':
      'Подписка на планы доступна только с понедельника по пятницу в вашем часовом поясе.',
    'user.investments.history.rateDay': '{{pct}}%/день',
    'user.investments.active.ratePerDay': '{{pct}}% / день',
    'user.dashboard.invest.detail.perDay': '{{pct}}% / день',
    'user.deposit.history.emptyTitle': 'Пока нет депозитов',
    'user.deposit.history.emptyDesc': 'История депозитов появится здесь',
    'user.stopLoss.slots.title': 'Мои слоты стоп-лосса',
    'user.stopLoss.explainer.title': 'Что такое защита стоп-лосс?',
    'user.stopLoss.explainer.body':
      'Стоп-лосс автоматически завершает инвестицию, когда её стоимость падает ниже заданного порога, защищая капитал от резких падений и волатильности.',
    'user.stopLoss.explainer.badge.nonRefundable': 'Невозвратный платёж',
    'user.stopLoss.explainer.badge.monitoring': 'Автоматический мониторинг 24/7',
  },

  bn: {
    'user.referral.link.hintLong':
      'আপনার ব্যক্তিগত লিঙ্ক দিয়ে বন্ধুদের MineMe-তে আমন্ত্রণ করুন এবং নেটওয়ার্ক বাড়াতে সাহায্য করুন।',
    'user.referral.stats.direct': 'সরাসরি রেফারেল',
    'user.referral.stats.indirect': 'পরোক্ষ রেফারেল',
    'user.referral.stats.directRate': 'লেভেল ১ কমিশন',
    'user.referral.stats.indirectRate': 'লেভেল ২ কমিশন',
    'user.referral.stats.rateValue': 'বিনিয়োগে {{pct}}%',
    'user.referral.stats.earnings': 'রেফারেল আয়',
    'user.referral.tree.title': 'আপনার রেফারেল নেটওয়ার্ক',
    'user.referral.tree.you': 'আপনি',
    'user.referral.tree.directLevel': 'সরাসরি স্তর',
    'user.referral.tree.indirectLevel': 'পরোক্ষ স্তর',
    'user.referral.tree.noDirect': 'এখনও কোনো সরাসরি রেফারেল নেই',
    'user.referral.tree.noIndirect': 'এখনও কোনো পরোক্ষ রেফারেল নেই',
    'user.referral.tree.directCount': '{{n}} সরাসরি রেফারেল',
    'user.referral.tree.indirectCount': '{{n}} পরোক্ষ রেফারেল',
    'user.withdraw.form.minAmount': 'ন্যূনতম উত্তোলন: {{amount}}',
    'user.withdraw.form.feeTitle': 'উত্তোলন ফি: {{pct}}%',
    'user.withdraw.form.feeBody':
      'উত্তোলনের {{pct}}% ফি কাটা হয়। আগাম প্ল্যান বাতিলের জন্য আলাদা ফি প্রযোজ্য।',
    'user.withdraw.form.noFeeBody':
      'ওয়ালেট উত্তোলনে প্ল্যাটফর্ম ফি নেই। আগাম প্ল্যান বাতিলের জন্য আলাদা ফি প্রযোজ্য।',
    'user.withdraw.rules.feeNote':
      'ওয়ালেট উত্তোলনে {{pct}}% প্ল্যাটফর্ম ফি প্রযোজ্য। আগাম প্ল্যান বাতিলের জন্য আলাদা ফি।',
    'user.withdraw.rules.noFeeNote':
      'ওয়ালেট উত্তোলনে প্ল্যাটফর্ম ফি নেই। আগাম প্ল্যান বাতিলের জন্য আলাদা ফি।',
    'user.withdraw.toast.tooLowAfterFee': 'প্ল্যাটফর্ম ফির পর পরিমাণ খুব কম',
    'user.withdraw.toast.minUsd': 'ন্যূনতম উত্তোলন {{amount}}',
    'user.withdraw.form.weekendOnlyHint':
      'ওয়ালেট উত্তোলন শনি ও রবিবারে উপলব্ধ (স্থানীয় সময়)। আগাম প্ল্যান বাতিল প্রভাবিত হয় না।',
    'user.withdraw.toast.weekendOnly':
      'ওয়ালেট উত্তোলন আপনার সময় অঞ্চলে শনি ও রবিবারে উপলব্ধ।',
    'user.withdraw.history.empty': 'এখনও কোনো উত্তোলন নেই। ইতিহাস এখানে দেখা যাবে।',
    'user.investments.modal.hintWeekdayOnly':
      'সুদ শুধুই সপ্তাহের দিনগুলোতে উপলব্ধ ব্যালেন্সে যোগ হয়',
    'user.investments.modal.toastWeekdayOnly':
      'আপনার টাইমজোনে প্ল্যান সাবস্ক্রিপশন শুধু সোম–শুক্র উপলব্ধ।',
    'user.investments.history.rateDay': '{{pct}}%/দিন',
    'user.investments.active.ratePerDay': '{{pct}}% / দিন',
    'user.dashboard.invest.detail.perDay': '{{pct}}% / দিন',
    'user.deposit.history.emptyTitle': 'এখনও কোনো জমা নেই',
    'user.deposit.history.emptyDesc': 'আপনার জমার ইতিহাস এখানে দেখা যাবে',
    'user.stopLoss.slots.title': 'আমার স্টপ-লস স্লট',
    'user.stopLoss.explainer.title': 'স্টপ-লস সুরক্ষা কী?',
    'user.stopLoss.explainer.body':
      'স্টপ-লস আপনার নির্ধারিত সীমার নিচে মূল্য নামলে স্বয়ংক্রিয়ভাবে বিনিয়োগ বন্ধ করে, হঠাৎ পতন ও অস্থিরতা থেকে মূলধন রক্ষা করে।',
    'user.stopLoss.explainer.badge.nonRefundable': 'অ-ফেরতযোগ্য পেমেন্ট',
    'user.stopLoss.explainer.badge.monitoring': '২৪/৭ স্বয়ংক্রিয় পর্যবেক্ষণ',
  },

  hi: {
    'user.referral.link.hintLong':
      'अपने व्यक्तिगत लिंक से दोस्तों को MineMe में आमंत्रित करें और नेटवर्क बढ़ाने में मदद करें।',
    'user.referral.stats.direct': 'प्रत्यक्ष रेफ़रल',
    'user.referral.stats.indirect': 'अप्रत्यक्ष रेफ़रल',
    'user.referral.stats.directRate': 'स्तर 1 कमीशन',
    'user.referral.stats.indirectRate': 'स्तर 2 कमीशन',
    'user.referral.stats.rateValue': 'निवेश पर {{pct}}%',
    'user.referral.stats.earnings': 'रेफ़रल आय',
    'user.referral.tree.title': 'आपका रेफ़रल नेटवर्क',
    'user.referral.tree.you': 'आप',
    'user.referral.tree.directLevel': 'प्रत्यक्ष स्तर',
    'user.referral.tree.indirectLevel': 'अप्रत्यक्ष स्तर',
    'user.referral.tree.noDirect': 'अभी कोई प्रत्यक्ष रेफ़रल नहीं',
    'user.referral.tree.noIndirect': 'अभी कोई अप्रत्यक्ष रेफ़रल नहीं',
    'user.referral.tree.directCount': '{{n}} प्रत्यक्ष रेफ़रल',
    'user.referral.tree.indirectCount': '{{n}} अप्रत्यक्ष रेफ़रल',
    'user.withdraw.form.minAmount': 'न्यूनतम निकासी: {{amount}}',
    'user.withdraw.form.feeTitle': 'निकासी शुल्क: {{pct}}%',
    'user.withdraw.form.feeBody':
      'निकासी राशि का {{pct}}% शुल्क काटा जाता है। जल्दी प्लान रद्दीकरण पर अलग शुल्क लागू होता है।',
    'user.withdraw.form.noFeeBody':
      'वॉलेट निकासी पर कोई प्लेटफ़ॉर्म शुल्क नहीं। जल्दी प्लान रद्दीकरण पर अलग शुल्क लागू होता है।',
    'user.withdraw.rules.feeNote':
      'वॉलेट निकासी पर {{pct}}% प्लेटफ़ॉर्म शुल्क लागू है। जल्दी प्लान रद्दीकरण पर अलग शुल्क।',
    'user.withdraw.rules.noFeeNote':
      'वॉलेट निकासी पर कोई प्लेटफ़ॉर्म शुल्क नहीं। जल्दी प्लान रद्दीकरण पर अलग शुल्क।',
    'user.withdraw.toast.tooLowAfterFee': 'प्लेटफ़ॉर्म शुल्क के बाद राशि बहुत कम है',
    'user.withdraw.toast.minUsd': 'न्यूनतम निकासी {{amount}} है',
    'user.withdraw.form.weekendOnlyHint':
      'वॉलेट निकासी केवल शनिवार और रविवार को उपलब्ध है (आपका स्थानीय समय)। जल्दी प्लान रद्दीकरण प्रभावित नहीं होता।',
    'user.withdraw.toast.weekendOnly':
      'वॉलेट निकासी आपके समय क्षेत्र में केवल शनिवार और रविवार को उपलब्ध है।',
    'user.withdraw.history.empty': 'अभी कोई निकासी नहीं। आपका इतिहास यहाँ दिखेगा।',
    'user.investments.modal.hintWeekdayOnly':
      'ब्याज केवल कार्यदिवसों पर उपलब्ध शेष में जमा होता है',
    'user.investments.modal.toastWeekdayOnly':
      'आपके समय क्षेत्र में प्लान सदस्यता केवल सोम–शुक्र उपलब्ध है।',
    'user.investments.history.rateDay': '{{pct}}%/दिन',
    'user.investments.active.ratePerDay': '{{pct}}% / दिन',
    'user.dashboard.invest.detail.perDay': '{{pct}}% / दिन',
    'user.deposit.history.emptyTitle': 'अभी कोई जमा नहीं',
    'user.deposit.history.emptyDesc': 'आपका जमा इतिहास यहाँ दिखेगा',
    'user.stopLoss.slots.title': 'मेरे स्टॉप-लॉस स्लॉट',
    'user.stopLoss.explainer.title': 'स्टॉप-लॉस सुरक्षा क्या है?',
    'user.stopLoss.explainer.body':
      'स्टॉप-लॉस आपकी निर्धारित सीमा से नीचे मूल्य गिरने पर निवेश स्वतः समाप्त करता है, अचानक गिरावट और अस्थिरता से मूलधन की रक्षा करता है।',
    'user.stopLoss.explainer.badge.nonRefundable': 'गैर-वापसी योग्य भुगतान',
    'user.stopLoss.explainer.badge.monitoring': '24/7 स्वचालित निगरानी',
  },

  'zh-CN': {
    'user.referral.link.hintLong': '用您的专属链接邀请好友加入 MineMe，一起壮大网络。',
    'user.referral.stats.direct': '直推人数',
    'user.referral.stats.indirect': '间推人数',
    'user.referral.stats.directRate': '一级佣金',
    'user.referral.stats.indirectRate': '二级佣金',
    'user.referral.stats.rateValue': '投资额的 {{pct}}%',
    'user.referral.stats.earnings': '推荐收益',
    'user.referral.tree.title': '您的推荐网络',
    'user.referral.tree.you': '您',
    'user.referral.tree.directLevel': '直推层级',
    'user.referral.tree.indirectLevel': '间推层级',
    'user.referral.tree.noDirect': '暂无直推用户',
    'user.referral.tree.noIndirect': '暂无间推用户',
    'user.referral.tree.directCount': '{{n}} 位直推',
    'user.referral.tree.indirectCount': '{{n}} 位间推',
    'user.withdraw.form.minAmount': '最低提现：{{amount}}',
    'user.withdraw.form.feeTitle': '提现手续费：{{pct}}%',
    'user.withdraw.form.feeBody':
      '从提现金额中扣除 {{pct}}% 平台手续费。提前取消计划另有单独费用。',
    'user.withdraw.form.noFeeBody':
      '钱包提现无平台手续费。提前取消计划另有单独费用。',
    'user.withdraw.rules.feeNote':
      '钱包提现收取 {{pct}}% 平台手续费。提前取消计划另有单独费用。',
    'user.withdraw.rules.noFeeNote':
      '钱包提现无平台手续费。提前取消计划另有单独费用。',
    'user.withdraw.toast.tooLowAfterFee': '扣除手续费后金额过低',
    'user.withdraw.toast.minUsd': '最低提现金额为 {{amount}}',
    'user.withdraw.form.weekendOnlyHint':
      '钱包提现仅在周六和周日开放（当地时间）。提前取消计划不受影响。',
    'user.withdraw.toast.weekendOnly':
      '钱包提现仅在您所在时区的周六和周日开放。',
    'user.withdraw.history.empty': '暂无提现记录。您的提现历史将显示在这里。',
    'user.investments.modal.hintWeekdayOnly':
      '利息仅在工作日计入可用余额',
    'user.investments.modal.toastWeekdayOnly':
      '在您所在时区，计划订阅仅限周一至周五。',
    'user.investments.history.rateDay': '{{pct}}%/日',
    'user.investments.active.ratePerDay': '{{pct}}% / 日',
    'user.dashboard.invest.detail.perDay': '{{pct}}% / 日',
    'user.deposit.history.emptyTitle': '暂无存款',
    'user.deposit.history.emptyDesc': '您的存款记录将显示在这里',
    'user.stopLoss.slots.title': '我的止损位',
    'user.stopLoss.explainer.title': '什么是止损保护？',
    'user.stopLoss.explainer.body':
      '当投资市值跌破您设定的阈值时，止损会自动终止投资，保护本金免受急跌和市场波动影响。',
    'user.stopLoss.explainer.badge.nonRefundable': '不可退款付款',
    'user.stopLoss.explainer.badge.monitoring': '全天候自动监控',
  },
};

export const panelUserPlatformTodayByLang = Object.fromEntries(
  Object.entries(panelUserPlatformTodayBase).map(([lang, entries]) => [
    lang,
    { ...entries, ...(panelStopLossHowLayoutByLang[lang] ?? {}) },
  ]),
);
